/**
 * BILA SIGN IN / UP FORM FIX
 */

(function ($) {
  "use strict";

  $(document).ready(function () {
    // ============= add floating labels =============
    function addFloatingLabels() {
      $(".edublink-login-item input").each(function () {
        var $input = $(this);
        var $container = $input.closest(".edublink-login-item");

        // Skip if label already exists or if it's a hidden input
        if (
          $container.find(".edublink-floating-label").length > 0 ||
          $input.attr("type") === "hidden"
        ) {
          return;
        }

        // Get placeholder text
        var placeholderText = $input.attr("placeholder");
        var inputId = $input.attr("id");

        // Skip if no placeholder
        if (!placeholderText) {
          return;
        }

        // Remove placeholder from input (for floating label effect)
        $input
          .removeAttr("placeholder")
          .data("original-placeholder", placeholderText);

        // Create label element
        var $label = $(
          '<label class="edublink-floating-label" for="' +
            inputId +
            '">' +
            placeholderText +
            "</label>",
        );

        // Insert label after input or before (depending on desired effect)
        $container.prepend($label);

        // Check if input has value to set initial label state
        if ($input.val().trim() !== "") {
          $container.addClass("has-value");
        }
      });
    }

    // Initial call
    addFloatingLabels();

    // Handle input events for floating labels
    $(document).on("input", ".edublink-login-item input", function () {
      var $input = $(this);
      var $container = $input.closest(".edublink-login-item");

      if ($input.val().trim() !== "") {
        $container.addClass("has-value");
      } else {
        $container.removeClass("has-value");
      }
    });

    // Re-add when switching tabs
    $("#edublink-register-form-trigger, #edublink-login-form-trigger").on(
      "click",
      function () {
        setTimeout(addFloatingLabels, 100);
      },
    );

    // CSS for floating labels
    if (!$("#edublink-floating-label-styles").length) {
      $("head").append(
        '<style id="edublink-floating-label-styles">\
          .edublink-login-item {\
            position: relative;\
            margin-bottom: 25px;\
          }\
          .edublink-floating-label {\
            position: absolute;\
            left: 10px;\
            top: 50%;\
            transform: translateY(-50%);\
            font-size: 16px;\
            color: #999;\
            pointer-events: none;\
            transition: all 0.2s ease;\
            background: transparent;\
            padding: 0 5px;\
            z-index: 1;\
          }\
          [dir="rtl"] .edublink-floating-label {\
            right: 10px;\
            left: auto;\
          }\
          .edublink-login-item.focused .edublink-floating-label,\
          .edublink-login-item.has-value .edublink-floating-label {\
            top: 0;\
            transform: translateY(-50%) scale(0.85);\
            background: white;\
            color: var(--theme-primary-color, #156db5);\
          }\
          .edublink-login-item input {\
            width: 100%;\
            padding: 12px 10px;\
            border: 1px solid var(--theme-color-border, #e5e5e5);\
            border-radius: 4px;\
            outline: none;\
          }\
          .edublink-login-item input:focus {\
            border-color: var(--theme-primary-color, #156db5);\
          }\
          /* Adjust for password toggle button */\
          .edublink-login-item .password-toggle {\
            z-index: 2;\
          }\
        </style>',
      );
    }
    // Fix for red border issue - remove validation styling on initial load
    $(".edublink-login-item input")
      .addClass("untouched")
      .removeClass("touched");

    // Track when user interacts with fields
    $(".edublink-login-item input").on("focus blur input", function () {
      $(this).addClass("touched").removeClass("untouched");
    });

    // Remove existing error messages when user starts typing
    $(document).on("input", ".edublink-login-item input", function () {
      $(this).closest(".edublink-login-item").find(".edublink-error").remove();
    });

    // ============= SHOW/HIDE PASSWORD FUNCTIONALITY WITH SVG =============
    function addPasswordToggle() {
      // Target both login password and register password fields
      $('.edublink-login-item input[type="password"]').each(function () {
        // Check if toggle already exists to avoid duplicates
        if (!$(this).parent().find(".password-toggle").length) {
          var passwordField = $(this);
          var container = passwordField.closest(".edublink-login-item");

          // Make container position relative for absolute positioning
          container.css("position", "relative");

          // SVG for eye open (visible password)
          var eyeOpenSvg =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" fill="currentColor"/>' +
            '<circle cx="12" cy="12" r="3" fill="currentColor"/>' +
            "</svg>";

          // SVG for eye closed (hidden password)
          var eyeClosedSvg =
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-4 .7l2.17 2.17C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>' +
            "</svg>";

          // Add toggle button with eye open SVG (default state)
          var toggleBtn = $(
            '<button type="button" class="password-toggle" aria-label="Show password">' +
              eyeOpenSvg +
              "</button>",
          );
          toggleBtn.css({
            position: "absolute",
            top: "10px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "5px",
            "line-height": "1",
            color: "#666",
            "z-index": "10",
            display: "flex",
            "align-items": "center",
            "justify-content": "center",
            "border-radius": "4px",
          });

          // Add hover effect
          toggleBtn.hover(
            function () {
              $(this).css("color", "#333");
            },
            function () {
              $(this).css("color", "#666");
            },
          );

          container.append(toggleBtn);

          // Toggle functionality
          toggleBtn.off("click").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var type =
              passwordField.attr("type") === "password" ? "text" : "password";
            passwordField.attr("type", type);

            // Toggle SVG icon
            if (type === "password") {
              $(this).html(eyeOpenSvg);
              $(this).attr("aria-label", "Show password");
            } else {
              $(this).html(eyeClosedSvg);
              $(this).attr("aria-label", "Hide password");
            }
          });
        }
      });
    }

    // Initialize password toggles
    addPasswordToggle();

    // Re-add toggles when switching tabs (since DOM might change)
    $("#edublink-register-form-trigger, #edublink-login-form-trigger").on(
      "click",
      function () {
        setTimeout(addPasswordToggle, 100);
      },
    );

    // ============= FORM SUBMISSION HANDLERS =============

    // Override login form submission
    $("#edublink-login-form")
      .off("submit")
      .on("submit", function (e) {
        e.preventDefault();

        var form = $(this);
        var submitBtn = form.find('input[type="submit"]');

        // Remove any existing error messages
        form.find(".edublink-error").remove();

        // Add loading spinner
        submitBtn.prop("disabled", true);
        submitBtn.css({
          "background-image":
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'%3E%3Cstyle%3E@keyframes spin%7B0%25%7Btransform:rotate(0deg)%7D100%25%7Btransform:rotate(360deg)%7D%7Dsvg%7Banimation:spin 1s linear infinite%7D%3C/style%3E%3Ccircle cx='12' cy='12' r='10' stroke='%23ffffff' stroke-width='3' fill='none' stroke-dasharray='31.4 31.4' /%3E%3C/svg%3E\")",
          "background-repeat": "no-repeat",
          "background-position": "left 10px center",
          "background-size": "20px",
          "padding-left": "40px",
        });

        // AJAX login
        $.ajax({
          url: form.attr("action"),
          type: "POST",
          data: form.serialize(),
          success: function (response) {
            if (response.success) {
              window.location.reload();
            } else {
              resetButton(submitBtn);
            }
          },
          error: function () {
            resetButton(submitBtn);
          },
          complete: function () {},
        });
      });

    // Override register form submission
    $("#edublink-register-form")
      .off("submit")
      .on("submit", function (e) {
        e.preventDefault();

        var form = $(this);
        var submitBtn = form.find('input[type="submit"]');
        var originalValue = "Sign up";

        // REMOVE SPACES FROM USERNAME BEFORE SUBMISSION
        var $usernameField = form.find("#reg_username");
        if ($usernameField.length) {
          var originalUsername = $usernameField.val();
          var sanitizedUsername = originalUsername.replace(/\s+/g, "");

          // Only update if spaces were found and removed
          if (originalUsername !== sanitizedUsername) {
            $usernameField.val(sanitizedUsername);

            // Optional: Add a subtle visual feedback that spaces were removed
            $usernameField.css("border-color", "#ffc107");
            setTimeout(function () {
              $usernameField.css("border-color", "");
            }, 1000);
          }
        }

        form.find(".edublink-error").remove();

        submitBtn.prop("disabled", true);
        submitBtn.css({
          "background-image":
            "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'%3E%3Cstyle%3E@keyframes spin%7B0%25%7Btransform:rotate(0deg)%7D100%25%7Btransform:rotate(360deg)%7D%7Dsvg%7Banimation:spin 1s linear infinite%7D%3C/style%3E%3Ccircle cx='12' cy='12' r='10' stroke='%23ffffff' stroke-width='3' fill='none' stroke-dasharray='31.4 31.4' /%3E%3C/svg%3E\")",
          "background-repeat": "no-repeat",
          "background-position": "left 10px center",
          "background-size": "20px",
          "padding-left": "40px",
        });

        $.ajax({
          url: form.attr("action"),
          type: "POST",
          data: form.serialize(),
          success: function (response) {
            if (response.success) {
              resetButton(submitBtn);
              setTimeout(function () {
                $("#edublink-login-form-trigger").click();
              }, 1500);
            } else {
              resetButton(submitBtn);
            }
          },
          error: function () {
            resetButton(submitBtn);
          },
          complete: function () {},
        });
      });

    // Helper function to reset button
    function resetButton(btn) {
      btn.prop("disabled", false);
      btn.css({
        "background-image": "none",
        "padding-left": "",
      });
    }

    // Add styles if not present
    if (!$("#edublink-custom-styles").length) {
      $("head").append(
        '<style id="edublink-custom-styles">\
                .edublink-login-item input[name="pwd"],\
                .edublink-login-item input[name="user_pass"],\
                    padding-right: 45px !important;\
                }\
                [dir="rtl"] .edublink-login-item input[name="pwd"],\
                [dir="rtl"] .edublink-login-item input[name="user_pass"],\
                    padding-left: 45px !important;\
                    padding-right: 0px !important;\
                }\
                .password-toggle {\
                    transition: all 0.2s ease;\
                    outline: none;\
                }\
                .password-toggle:focus {\
                    outline: none;\
                }\
                .password-toggle{\
                    right: 9px;\
                }\
                [dir="rtl"] .password-toggle{\
                    left: 9px;\
                    right: auto;\
                }\
                .password-toggle svg {\
                    display: block;\
                }\
            </style>',
      );
    }

    // Switch between login/register
    $("#edublink-register-form-trigger, #edublink-login-form-trigger")
      .off("click")
      .on("click", function () {
        var targetId =
          $(this).attr("id") === "edublink-register-form-trigger"
            ? "tab2"
            : "tab1";
        $(".edublink-login-form-item").hide();
        $("#" + targetId).show();

        $(".login-tab-title").removeClass("active");
        if (targetId === "tab2") {
          $(".register-item").addClass("active");
        } else {
          $(".login-tab-title.login-item").addClass("active");
        }

        $(".edublink-error").remove();

        // Re-add password toggles when switching tabs
        setTimeout(addPasswordToggle, 100);
      });
  });
})(jQuery);
